import { createEvent, createStore } from 'effector';
import { MenuType } from '@nx-frontend/shared/types';

interface PortalMenuState {
  expandedMenuTypes: MenuType[];
}
const initialMenusState: PortalMenuState = {
  expandedMenuTypes: [],
};

export const setExpandedMenuTypesEvent = createEvent<MenuType[]>();
export const $portalMenuState = createStore(initialMenusState).on(setExpandedMenuTypesEvent, (state, menuTypes) => {
  return {
    ...state,
    expandedMenuTypes: menuTypes,
  };
});

export const $expandedPortalMenuTypes = $portalMenuState.map((state) => state.expandedMenuTypes);
